import React, { useEffect, useState } from "react";
import { Offcanvas, Table, Form } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { ApiHook } from "../../hooks/apiHook";
import { Alert, Grow, Link as MuiLink } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import SubmitButton from "../Common/buttons/SubmitButton";
import { useQueryClient } from "@tanstack/react-query";
import { useSelector } from "react-redux";
import CurrencyConverter from "../../Currency/CurrencyConverter";
import { reverseNumberDisplay } from "../../utils/currencyNumberDisplay";
import { toast } from "react-toastify";
import CurrencyInput from "react-currency-input-field";
import { Link } from "react-router-dom";

const PayoutRequest = ({ show, handleClose, data ,handleToggleRegisterModal}) => {
  const { t } = useTranslation();
  const queryClient = useQueryClient();
  const [payoutData, setPayoutData] = useState({
    payoutAmount: "",
    bep20Address:  "",
    transactionPassword: "",
  });  
  const [errorMessage, setErrorMessage] = useState({
    payoutAmount: null,
    bep20Address : null,
    transactionPassword: null,
  });
  const userSelectedCurrency = useSelector(
    (state) => state?.user?.selectedCurrency
  );
  const conversionFactor = useSelector(
    (state) => state?.user?.conversionFactor
  );
  const defaultCurrencyJson = useSelector(
    (state) => state?.user?.loginResponse?.defaultCurrency
  );

  useEffect(() => {
    if (data?.bep20Address) {
      setPayoutData((prev) => ({
        ...prev,
        bep20Address: data.bep20Address,
      }));
    }
  }, [show,data?.bep20Address]);

  const defaultCurrency = defaultCurrencyJson
    ? JSON.parse(defaultCurrencyJson)
    : null;
  const payoutMutation = ApiHook.CallPayoutRequest();

  const handleChange = (e) => {
    const { id, value } = e.target;
    setPayoutData((prevData) => ({
      ...prevData,
      [id]: value,
    }));
    setErrorMessage((prevData) => ({
      ...prevData,
      [id]: null,
    }));
    if (value === null || value === "") {
      setErrorMessage((prev) => ({
        ...prev,
        [id]: "*Required",
      }));
    }
  };


  const [acceptPolicy, setAcceptPolicy] = useState(false);
  const [policyError, setPolicyError] = useState("");

  const handlePolicyCheck = () => {
    if (!acceptPolicy) {
      setPolicyError(t("Required"));
      setTimeout(() => setPolicyError(""), 2000);
      return false;
    }
    return true;
  };

  const isFormValid = () => {
    return (
      payoutData?.payoutAmount > 0 &&
      payoutData?.transactionPassword.trim() !== ""
    );
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!isFormValid()) {
      return;
    }
    if (!handlePolicyCheck()) return;
    if (!payoutData.bep20Address) {
      setErrorMessage((prevData) => ({
        ...prevData,
        bep20Address: "Please enter BEP20 Address",
      }))
      return 
    }
    if(!data?.isKycVerified) {
      toast.error("Please verify your KYC before proceeding.");
      return
    }
    let convertAmount;
    if (userSelectedCurrency.id === defaultCurrency.id) {
      convertAmount = reverseNumberDisplay(
        CurrencyConverter(payoutData?.payoutAmount, conversionFactor, 0)
      );
    } else {
      convertAmount = reverseNumberDisplay(
        CurrencyConverter(payoutData?.payoutAmount, conversionFactor, 1)
      );
    }
    const postData = {
      payoutAmount: convertAmount,
      bep20Address : payoutData?.bep20Address,
      transactionPassword: payoutData?.transactionPassword,
    };
    await payoutMutation.mutateAsync(postData, {
      onSuccess: (res) => {
        if (res.status === 200) {
          setErrorMessage({
            username: null,
            transactionPassword: null,
          });
          setPayoutData({
            payoutAmount: "",
            transactionPassword: "",
          });
          queryClient.invalidateQueries({
            queryKey: ["payout-request-details"],
          });
          queryClient.invalidateQueries({
            queryKey: ["payout-details"],
          });
          queryClient.invalidateQueries({
            queryKey: ["payout-tiles"],
          });
          handleClose(false);
        } else {
          if (res?.data?.code === 1015) {
            setErrorMessage((prevErrors) => ({
              ...prevErrors,
              transactionPassword: t(res?.data?.description),
            }));
          } else if (res?.data?.code === 1027) {
            setErrorMessage((prevErrors) => ({
              ...prevErrors,
              payoutAmount: t(res?.data?.description),
            }));
          } else if (res?.data?.code === 1073) {
            setErrorMessage((prevErrors) => ({
              ...prevErrors,
              transactionPassword: t("addBankDetails"),
            }));
            toast.error(t(res?.data?.description))
          } else if (res?.data?.code === 1028) {
            setErrorMessage((prevErrors) => ({
              ...prevErrors,
              payoutAmount: t(res?.data?.description),
            }));
          } else if (res?.data?.code === 1025) {
            setErrorMessage((prevErrors) => ({
              ...prevErrors,
              payoutAmount: t(res?.data?.description),
            }));
          } else if (res?.data?.code) {
            toast.error(t(res?.data?.description));
          } else {
            toast.error(t(res?.data?.message));
          }
        }
      },
    });
  };
  return (
    <Offcanvas
      show={show}
      placement="end"
      onHide={() => {
        handleClose();
        setPayoutData({
          payoutAmount:"",
          transactionPassword: "",
        });
        setErrorMessage({
          username: null,
          transactionPassword: null,
        });
      }}
      scroll={true}
      backdrop={true}
    >
      <Offcanvas.Header closeButton>
        <Offcanvas.Title>{t("payoutRequest")}</Offcanvas.Title>
      </Offcanvas.Header>
      <Offcanvas.Body>
        <Form>
          <Form.Group className="mb-3 amount-field">
            {/* {data?.isPayoutMethodUpdated === false && (
                <Grow in={true} timeout={300}>
                  <div>
                    <Alert severity="info">
                      <RouterLink to="/profile?payout=bank-transfer" style={{  color: 'inherit' }}>
                        {t('updatePayout')}
                      </RouterLink>
                    </Alert>
                  </div>
              </Grow>
              )} */}
              {data?.isKycVerified === false && (
                <Grow in={true} timeout={300}>
                  <div>
                    <Alert severity="warning">
                      <RouterLink to="/kyc-details" style={{  color: 'inherit' }}>
                        Please verify your KYC to proceed with the claim.
                      </RouterLink>
                    </Alert>
                  </div>
              </Grow>
              )}
              <br/>
            <Form.Label>{t("withdrawalAmount")}</Form.Label>
            <div className="input-group">
              <Form.Control as="select" disabled className="max-40">
                <option value="">{userSelectedCurrency?.symbolLeft}</option>
              </Form.Control>
              <CurrencyInput
                name="payoutAmount"
                id="payoutAmount"
                placeholder={t("amount")}
                value={payoutData?.payoutAmount}
                onValueChange={(value, id) =>
                  handleChange({ target: { value, id } })
                }
                required
                allowNegativeValue={false}
              />
              <div className="number-field-invalid-feedback">
                {errorMessage.payoutAmount}
              </div>
            </div>
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>{t("transactionPassword")} *</Form.Label>
            <Form.Control
              id="transactionPassword"
              type="password"
              placeholder={t("transactionPassword")}
              onChange={(e) => handleChange(e)}
              value={payoutData?.transactionPassword}
              required
              isInvalid={errorMessage?.transactionPassword !== null}
            />
            <Form.Control.Feedback type="invalid">
              {errorMessage?.transactionPassword && (
                <Link to="/profile" style={{color:"red"}}>
                  {errorMessage.transactionPassword}
                </Link>
              )}
            </Form.Control.Feedback>
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>{t("USDC - BEP20 address")} *</Form.Label>
            <Form.Control
              id="bep20Address"
              type="text"
              placeholder={t("BEP20 Address")}
              onChange={(e) => handleChange(e)}
              value={payoutData.bep20Address}
              required
            />
            {errorMessage.bep20Address && <span style={{ marginTop: ".5rem" }} className="error-message-validator">
                {errorMessage.bep20Address}</span>}

          </Form.Group>

          <div style={{ marginTop: "1rem" }}>
          <div className="regsiter_form_box_tandc">
            <label className="d-flex" htmlFor="box">
              <input
                type="checkbox"
                id="box"
                style={{ marginRight: "5px" }}
                checked={acceptPolicy}
                onChange={(e) => setAcceptPolicy(e.target.checked)}
              />
            </label>

            <a
              data-bs-toggle="modal"
              className="pop_terms_btn"
              onClick={handleToggleRegisterModal}
            >
              {t("I Agree to the Terms and Conditions")}
              <span className="text-danger"> ٭ </span>
            </a>

            {policyError && (
              <span style={{ marginLeft: ".5rem" }} className="error-message-validator">
                {policyError}
              </span>
            )}
          </div>
        </div>

          <SubmitButton
            isSubmitting={!isFormValid() || payoutMutation.isLoading}
            click={handleSubmit}
            text={payoutMutation.isLoading ? "Submitting..." : "Submit"}
            className={"btn btn-primary submit_btn"}
          />
        </Form>
      <div style={{margin:'1rem 0'}}>
      {data?.payoutFee !== 0 && (
          <p>
            {t("an_additional_amount_of")}
            <span className="popAmntVal">
              {data?.payoutFeeMode === "percentage"
                ? `${data?.payoutFee} %`
                : `${userSelectedCurrency?.symbolLeft} ${CurrencyConverter(
                  Number(data?.payoutFee),
                  conversionFactor
                )}`}
            </span>
            {t("will_be_debited_as_payout_fee")}
          </p>
        )}
      </div>

      </Offcanvas.Body>
    </Offcanvas>
  );
};

export default PayoutRequest;
